module.exports = __webpack_public_path__ + "img/cases-brand-hla-10.994ea839.png";